var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import TagManager from 'react-gtm-module';
import storageService from '../../../utils/storageService';
/** pushToDataLayer takes and event name and a data layer and pushes it to GTM data layer for usage */
export var pushToDataLayer = function (key, source, event, dataLayer) {
    var _a;
    if (key === void 0) { key = 'apt'; }
    if (source === void 0) { source = 'cms'; }
    if (event === void 0) { event = 'event'; }
    if (dataLayer === void 0) { dataLayer = {}; }
    var gtmId = process.env.GTM_ID || '';
    if (gtmId !== '') {
        TagManager.dataLayer({
            dataLayer: (_a = {},
                _a[key] = __assign(__assign({}, dataLayer), { source: source, event: event }),
                _a.event = "".concat(key, ".").concat(source, ".").concat(event),
                _a),
            gtmId: gtmId,
        });
    }
};
/** fetches the signup token from local storage */
export var storageGetUserToken = function () {
    var token = storageService.getItem('token') || '';
    var parsedToken = {};
    try {
        parsedToken = JSON.parse(atob(token.split('.')[1]));
    }
    catch (e) { }
    return {
        userId: (parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.sub) || 'unknown',
    };
};
/** fetches the signup token from local storage */
export var storageGetSignupToken = function () {
    var token = storageService.getItem('token') || '';
    var parsedToken = {};
    try {
        parsedToken = JSON.parse(atob(token.split('.')[1]));
    }
    catch (e) { }
    return {
        campaign: (parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.campaign) || 'default',
        signupId: (parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.signupId) || 'unknown',
    };
};
